export default "__VITE_ASSET__CUBhALo8__"